import React from 'react';

import type { SelectTextFieldTranslations } from '@lumx/react';

import { GLOBAL, useTranslate } from '@lumapps/translations';

import { LUMX } from '../keys';

/**
 * Default LumApps translations for the DS `SelectTextField` (the DS ships none).
 *
 * @param label the field label, used to name the selected chips list ("Selected <label>")
 */
export const useSelectTextFieldTranslations = (label: string): SelectTextFieldTranslations => {
    const { translateKey, translateAndReplace, pluralize } = useTranslate();

    return React.useMemo(
        () => ({
            clearLabel: translateKey(GLOBAL.CLEAR),
            showSuggestionsLabel: translateKey(GLOBAL.SHOW_SUGGESTIONS),
            chipGroupLabel: translateAndReplace(LUMX.SELECTED_VALUES_LIST_LABEL, { SELECT_LABEL: label }),
            chipRemoveLabel: translateKey(GLOBAL.REMOVE),
            loadingMessage: translateKey(GLOBAL.LOADING),
            emptyMessage: translateKey(GLOBAL.NO_RESULTS),
            nbOptionMessage: (n: number) =>
                translateAndReplace(pluralize(GLOBAL.NB_OPTIONS_AVAILABLE, n), { NB: n }) as string,
            errorMessage: translateKey(GLOBAL.SERVICE_UNAVAILABLE),
            errorTryReloadMessage: translateKey(GLOBAL.TRY_RELOAD),
        }),
        [label, translateKey, translateAndReplace, pluralize],
    );
};
